import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiCall } from "services/api";
import { ActivityParams } from "./types";

export const getActivity = createAsyncThunk(
  "/activity",
  async ({ params }: { params: ActivityParams }, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/activity", { params });

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getWorkspaceActivity = createAsyncThunk(
  "/activity/workspace",
  async (
    { id, params }: { id: number; params: ActivityParams },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall().get(`/activity/workspace/${id}`, {
        params: params ? params : {},
      });

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
